import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { shopApi, TOKEN_KEY } from "@/lib/shopApi";
import { API } from "@/lib/api";

const MemberContext = createContext(null);

const cartKey = (id) => `atl_cart_${id}`;

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null); // null=checking, false=guest
  const [cart, setCart] = useState([]);
  const [cartReady, setCartReady] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(TOKEN_KEY)) return setMember(false);
    shopApi.get("/member/auth/me").then((r) => setMember(r.data)).catch(() => setMember(false));
  }, []);

  useEffect(() => {
    if (member) setCart(JSON.parse(localStorage.getItem(cartKey(member.id)) || "[]"));
    else setCart([]);
    setCartReady(!!member);
  }, [member?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const persist = useCallback((next) => {
    setCart(next);
    if (member) localStorage.setItem(cartKey(member.id), JSON.stringify(next));
  }, [member]);

  const login = async (email, password) => {
    const { data } = await shopApi.post("/member/auth/login", { email, password });
    sessionStorage.setItem(TOKEN_KEY, data.token);
    setMember(data.member);
    return data.member;
  };

  const logout = () => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    setMember(false);
    if (token) fetch(`${API}/member/auth/logout`, { method: "POST", headers: { Authorization: `Bearer ${token}` }, keepalive: true }).catch(() => {});
  };

  const addToCart = (p, qty = 1) => {
    const exists = cart.find((i) => i.product_id === p.id);
    const next = exists
      ? cart.map((i) => (i.product_id === p.id ? { ...i, qty: Math.min(99, i.qty + qty) } : i))
      : [...cart, { product_id: p.id, name: p.name, size: p.size, price: p.price, qty }];
    persist(next);
  };
  const setQty = (pid, qty) => persist(qty < 1 ? cart.filter((i) => i.product_id !== pid) : cart.map((i) => (i.product_id === pid ? { ...i, qty: Math.min(99, qty) } : i)));
  const clearCart = () => persist([]);
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  return (
    <MemberContext.Provider value={{ member, setMember, login, logout, cart, cartReady, addToCart, setQty, clearCart, cartCount }}>
      {children}
    </MemberContext.Provider>
  );
}

export const useMember = () => useContext(MemberContext);
